import { put, takeEvery } from "redux-saga/effects";
import VideoEvents from "./VideoEvents";
import VideoApi from "./VideoApi";
import { Video, VideoPDF } from "./models/Video";
import {
    addVideoReaction,
    addVideoReactionComplete,
    createVideo,
    AddVideoComment,
    AddVideoCommentComplete,
    UpdateVideoComment,
    UpdateVideoCommentComplete,
    DeleteVideoComment,
    DeleteVideoCommentComplete,
    // ReplayToVideoComment,
    // ReplayToVideoCommentComplete,
    createVideoComplete,
    deleteExtraMaterial,
    deleteVideo,
    incrementVideoViewCount,
    AddViewingHistory,
    loadVideoComplete,
    loadVideoList,
    loadVideoListComplete,
    loadVideoStarted,
    updateVideo,
    uploadExtraMaterial,
    uploadExtraMaterialComplete,
    getTagList,
    getTagListComplete,
    AddVideo,
    AddVideoComplete,
    AddVideoFailed,
    EditVideo,
    EditVideoComplete,
    EditVideoFailed,
    UploadDocumentComplete,
    UploadDocumentFailed,
    DeleteVideo,
    DeleteVideoComplete,
    DeleteVideoFailed,
    GetVideoSlide,
    GetVideoSlideComplete,
    UploadVideoSlide,
    UploadVideoSlideComplete,
    EditVideoSlide,
    EditVideoSlideFailed,
    EditVideoSlideComplete,
    DeleteVideoSlide,
    DeleteVideoSlideFailed,
    DeleteVideoSlideComplete,
    UpdateVideoStatistics,
    createNewTag,
    createNewTagCompleted,
    createNewTagFailed,
    getAllContents,
    getAllContentsComplete,
} from "./VideoActions";
import { VideoReaction } from "./models/VideoReaction";
import { VideoComment, VideoCommentChangeSet } from "./models/VideoComment";
import { VideoExtraMaterial } from "./models/VideoExtraMaterial";
import { FilterResult, Tag } from "./models/VideoFilter";
import { ErrorResponse } from "../../models/store";

function* getAllContentsWorker({ userId }: ReturnType<typeof getAllContents>) {
    const allContents: FilterResult = yield VideoApi.getAllContents(userId);
    console.log("getAllContentsWorker :", allContents);
    yield put(getAllContentsComplete(allContents));
}

function* loadAllWorker() {
    const videos: Video[] = yield VideoApi.getAll();
    yield put(loadVideoListComplete(videos));
}

function* loadVideoWorker({ videoId, userId }: ReturnType<typeof loadVideoStarted>) {
    if (videoId && userId) {
        const video: Video = yield VideoApi.get(videoId, userId);
        yield put(loadVideoComplete(video));
    }
}

function* createVideoWorker({ formData }: ReturnType<typeof createVideo>) {
    yield VideoApi.create(formData);
    yield put(createVideoComplete());
    // TODO consider making backend return something (video or at least ID)
    yield put(loadVideoList());
}

function* deleteVideoWorker({ videoId }: ReturnType<typeof deleteVideo>) {
    yield VideoApi.delete(videoId);
}

function* updateVideoWorker({ videoId, changeSet }: ReturnType<typeof updateVideo>) {
    yield VideoApi.update(videoId, changeSet);
}

function* uploadExtraMaterialWorker({ videoId, formData }: ReturnType<typeof uploadExtraMaterial>) {
    const material: VideoExtraMaterial = yield VideoApi.uploadExtraMaterial(videoId, formData);
    yield put(uploadExtraMaterialComplete(material));
}

function* deleteExtraMaterialWorker({ materialId }: ReturnType<typeof deleteExtraMaterial>) {
    yield VideoApi.deleteExtraMaterial(materialId);
}

function* addViewingHistoryWorker({
    userId,
    videoId,
    progressMillis,
}: ReturnType<typeof AddViewingHistory>) {
    yield VideoApi.addViewingHistory(userId, videoId, progressMillis);
}
function* IncrementVideoViewCountWorker({
    userId,
    videoId,
}: ReturnType<typeof incrementVideoViewCount>) {
    yield VideoApi.incrementViews(userId, videoId);
}

// コメントの追加
function* AddVideoCommentWorker({ videoCommentChangeSet }: ReturnType<typeof AddVideoComment>) {
    const savedComment: VideoComment = yield VideoApi.addVideoComment(videoCommentChangeSet);
    yield put(AddVideoCommentComplete(savedComment));
}

// コメントの編集
function* UpdateVideoCommentWorker({
    videoCommentChangeSet,
}: ReturnType<typeof UpdateVideoComment>) {
    const savedComment: VideoCommentChangeSet = yield VideoApi.updateVideoComment(
        videoCommentChangeSet
    );
    yield put(UpdateVideoCommentComplete(videoCommentChangeSet.videoId, savedComment));
}

// コメントの削除
function* DeleteVideoCommentWorker({ id, userId, videoId }: ReturnType<typeof DeleteVideoComment>) {
    const savedComment: VideoCommentChangeSet = yield VideoApi.deleteVideoComment(
        id,
        userId,
        videoId
    );
    yield put(DeleteVideoCommentComplete(videoId, savedComment));
}

// // コメントの返信
// function* replayVideoCommentWorker({
//     videoCommentChangeSet,
// }: ReturnType<typeof addVideoComment>) {
//     const savedComment: VideoComment = yield VideoApi.replayToVideoComment(videoCommentChangeSet);
//     yield put(replayToVideoCommentComplete(savedComment));
// }

function* createVideoReactionWorker({
    videoReactionChangeSet,
}: ReturnType<typeof addVideoReaction>) {
    const reaction: VideoReaction = yield VideoApi.createReaction(videoReactionChangeSet);
    yield put(addVideoReactionComplete(reaction));
}

// 新規Tag作成
function* createNewTagWorker({ newTag, tagInput }: ReturnType<typeof createNewTag>) {
    yield VideoApi.createNewTag(newTag);
    const result: Tag[] = yield VideoApi.getTagList(tagInput);
    if (result instanceof ErrorResponse) {
        if (result.response && result.response.status === 500) {
            yield put(createNewTagFailed(result, result.stack));
        }
    } else {
        yield put(createNewTagCompleted(result));
    }
}

function* loadTagList({ tagInput }: ReturnType<typeof getTagList>) {
    const filterResult: Tag[] = yield VideoApi.getTagList(tagInput);
    yield put(getTagListComplete(filterResult));
}

// ビデオ追加
function* AddVideoWorker({ video }: ReturnType<typeof AddVideo>) {
    const addVideo: ErrorResponse | null = yield VideoApi.AddVideo(video);
    if (addVideo && addVideo.response && addVideo.response.status !== 200) {
        yield put(AddVideoFailed());
    } else {
        yield put(AddVideoComplete());
    }
}

// ビデオ編集
function* EditVideoWorker({ editVideo }: ReturnType<typeof EditVideo>) {
    const updateVideo: Video | ErrorResponse = yield VideoApi.EditVideo(editVideo);
    if (updateVideo instanceof ErrorResponse) {
        if (updateVideo.response && updateVideo.response.status !== 200) {
            yield put(EditVideoFailed());
        }
    } else {
        if (editVideo.documentName.length > 0 || editVideo.materialId.length > 0) {
            const updateVideoInfo: Video = updateVideo;
            const uploadDocument: Video | ErrorResponse = yield VideoApi.UploadDocument({
                userId: editVideo.userId,
                videoId: updateVideoInfo.id,
                materialId: editVideo.materialId,
                documentFile: editVideo.documentFile,
                documentName: editVideo.documentName,
            });
            if (uploadDocument instanceof ErrorResponse) {
                if (uploadDocument.response && uploadDocument.response.status !== 200) {
                    yield put(EditVideoComplete(updateVideo));
                    yield put(UploadDocumentFailed());
                }
            } else {
                yield put(EditVideoComplete(updateVideo));
                yield put(UploadDocumentComplete(uploadDocument));
            }
        } else {
            yield put(EditVideoComplete(updateVideo));
        }
    }
}

// ビデオ削除
function* DeleteVideoWorker({ videoId, videoType }: ReturnType<typeof DeleteVideo>) {
    const response: Video[] | ErrorResponse = yield VideoApi.DeleteVideo(videoId, videoType);
    if (response instanceof ErrorResponse) {
        if (response.response && response.response.status !== 200) {
            yield put(DeleteVideoFailed());
        }
    } else {
        yield put(DeleteVideoComplete(videoId));
    }
}

// ビデオスライド資料取得
function* GetVideoSlideWorker({ videoId, fileId }: ReturnType<typeof GetVideoSlide>) {
    const response: VideoPDF = yield VideoApi.GetVideoSlide(videoId, fileId);
    yield put(GetVideoSlideComplete(response));
}

// ビデオスライド追加・編集・削除
function* UploadVideoSlideWorker({ uploadVideoSlide }: ReturnType<typeof UploadVideoSlide>) {
    const response: VideoPDF = yield VideoApi.UpdateVideoSlide(uploadVideoSlide);
    yield put(UploadVideoSlideComplete(response));
}

function* EditVideoSlideWorker({ editVideoSlide }: ReturnType<typeof EditVideoSlide>) {
    const response: VideoPDF = yield VideoApi.UpdateVideoSlide(editVideoSlide);
    if (response instanceof ErrorResponse) {
        if (response.response && response.response.status !== 200) {
            yield put(EditVideoSlideFailed());
        }
    } else {
        yield put(EditVideoSlideComplete(editVideoSlide.videoId, response));
    }
}

function* DeleteVideoSlideWorker({ videoId }: ReturnType<typeof DeleteVideoSlide>) {
    const response: null | ErrorResponse = yield VideoApi.DeleteVideoSlide(videoId);
    if (response instanceof ErrorResponse) {
        if (response.response && response.response.status !== 200) {
            yield put(DeleteVideoSlideFailed());
        }
    } else {
        yield put(DeleteVideoSlideComplete(videoId));
    }
}

// 統計情報更新
function* UpdateVideoStatisticsWorker({
    userId,
    videoId,
    videoTag,
    videoTitle,
    videoUrl,
    viewDurationMillis,
    newWatch,
}: ReturnType<typeof UpdateVideoStatistics>) {
    yield VideoApi.UpdateVideoStatistics(
        userId,
        videoId,
        videoTag,
        videoTitle,
        videoUrl,
        viewDurationMillis,
        newWatch
    );
}

export default function* VideoSaga() {
    yield takeEvery(VideoEvents.getAllContentsStarted, getAllContentsWorker);
    yield takeEvery(VideoEvents.LoadVideoListStarted, loadAllWorker);
    yield takeEvery(VideoEvents.LoadVideoStarted, loadVideoWorker);
    yield takeEvery(VideoEvents.CreateStarted, createVideoWorker);
    yield takeEvery(VideoEvents.AddViewingHistory, addViewingHistoryWorker);
    yield takeEvery(VideoEvents.IncrementViewCount, IncrementVideoViewCountWorker);
    yield takeEvery(VideoEvents.Delete, deleteVideoWorker);
    yield takeEvery(VideoEvents.Update, updateVideoWorker);
    yield takeEvery(VideoEvents.UploadExtraMaterials, uploadExtraMaterialWorker);
    yield takeEvery(VideoEvents.DeleteExtraMaterials, deleteExtraMaterialWorker);
    yield takeEvery(VideoEvents.AddVideoCommentStarted, AddVideoCommentWorker);
    yield takeEvery(VideoEvents.UpdateVideoCommentStarted, UpdateVideoCommentWorker);
    yield takeEvery(VideoEvents.DeleteVideoCommentStarted, DeleteVideoCommentWorker);
    // yield takeEvery(VideoEvents.ReplayToVideoStarted, ReplayVideoCommentWorker);
    yield takeEvery(VideoEvents.ReactStarted, createVideoReactionWorker);
    yield takeEvery(VideoEvents.createNewTagStarted, createNewTagWorker);
    yield takeEvery(VideoEvents.getTagListStarted, loadTagList);
    yield takeEvery(VideoEvents.AddVideoStarted, AddVideoWorker);
    yield takeEvery(VideoEvents.EditVideoStarted, EditVideoWorker);
    yield takeEvery(VideoEvents.DeleteVideoStarted, DeleteVideoWorker);
    yield takeEvery(VideoEvents.GetVideoSlide, GetVideoSlideWorker);
    yield takeEvery(VideoEvents.UploadVideoSlideStarted, UploadVideoSlideWorker);
    yield takeEvery(VideoEvents.EditVideoSlideStarted, EditVideoSlideWorker);
    yield takeEvery(VideoEvents.DeleteVideoSlideStarted, DeleteVideoSlideWorker);
    yield takeEvery(VideoEvents.UpdateVideoStatistics, UpdateVideoStatisticsWorker);
}
